var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wm-apply-box border_box"},[_c('iframe',{attrs:{"src":_vm.pageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }